import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { InteractionType } from '@azure/msal-browser';
import { AuthenticatedTemplate, MsalAuthenticationTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import Routes from './pages/Routes';
import Navigation from './components/navigation/Navigation';

import { loginRequest } from './security/authConfig';
import SwitchButton from './components/button/SwitchButton';
import { SwitchContextProvider } from './components/button/SwitchButtonContext';

const baseName = process.env.PUBLIC_URL || '/';

const Root: React.FC = () => {
  const authRequest = {
    ...loginRequest,
  };
  return (
    <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest}>
      <BrowserRouter basename={baseName}>
        <AuthenticatedTemplate>
          <Navigation />
          <SwitchContextProvider>
            <SwitchButton />
            <Routes />
          </SwitchContextProvider>
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>NOT AUTHENTICATED!</UnauthenticatedTemplate>
      </BrowserRouter>
    </MsalAuthenticationTemplate>
  );
};

export default Root;
